import { Grid, Typography, TextField, Button, Link, Radio, RadioGroup } from '@mui/material'
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { sendGeneralRequest } from '../../../../../features/generalRequest';
import { makeStyles } from '@mui/styles';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { useNavigate } from 'react-router-dom';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import colors from '../../../../colors';
import { texts } from '../../../../general/texts';
import SingleExpandedInvoice from '../SingleExpandedInvoice';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Calendar } from 'primereact/calendar';
import { FloatLabel } from 'primereact/floatlabel';
import Switch from '@mui/material/Switch';
import { selectUserInfo } from '../../../../../features/userInfo/userInfoSlice';
import FormControlLabel from '@mui/material/FormControlLabel';
import moment from 'moment';

export const AddDriversTpl = (props) => {

    const navigate = useNavigate()
    const userInfo = useSelector(selectUserInfo)
    const [detailList, setDetailList] = useState(false)
    const isSmallScreen = useMediaQuery('(max-width:700px)')
    const [date, setDate] = useState(null)
    const [invoice, setInvoice] = useState(null)
    const [isSecondDriver, setIsSecondDriver] = useState(false)
    const [state, setState] = React.useState({
        token: props.data.globalDataSliceState.token,
        // driverName: isClientFirstDriver ? userInfo.name : '',
        // driverSurname: '',
        // driverID: isClientFirstDriver ? userInfo.idNumber : '',
        // driverBirth: '',
        secondDriverName: '',
        secondDriverFatherName: '',
        secondDriverSurname: '',
        secondDriverID: '',
        secondDriverBirth: new Date(2000, 0, 1),
        secondDriverGender: ''
    })
    const dispatch = useDispatch()

    const today = new Date();
    const minAllowedDate = new Date(today.getFullYear() - 100, today.getMonth(), today.getDate()); // Optional: Set a reasonable min age
    const maxAllowedDate = new Date(today.getFullYear() - 18, today.getMonth(), today.getDate()); // Must be at least 18 years old

    const handleTextFieldChange = (prop) => (e) => {
        setState({
            ...state,
            [prop]: e.target.value
        })
    }

    // const automaticUpdate = (e, driver) => {
    //     if (driver === 'first') {
    //         setIsClientFirstDriver(e.target.checked)
    //         setState({
    //             ...state,
    //             ['driverName']: e.target.checked ? userInfo.name.split(" ")[0] : '',
    //             ['driverSurname']: e.target.checked ? userInfo.name.split(" ")[1] : ''
    //         })
    //     } else {
    //         setIsClientSecondDriver(e.target.checked)
    //         setState({
    //             ...state,
    //             ['secondDriverName']: e.target.checked ? userInfo.name.split(" ")[0] : '',
    //             ['secondDriverSurname']: e.target.checked ? userInfo.name.split(" ")[1] : ''
    //         })
    //     }
    // }

    const parseDate = (input) => {
        const parsedDate = moment(input, 'DD/MM/yyyy');
        const formattedDate = parsedDate.format('DD/MM/YYYY');
        return formattedDate
    }
    const getPremiumForPolicy = () => {
        dispatch(sendGeneralRequest({ request: { token: state.token, trxid: props.transID, startDate: parseDate(date) }, baseUrlKey: 'services', endpoint: 'SigurimeMotorrike/GetPremiumForPolicy' })).then(response => {
            if (response.payload.response.success) {
                setInvoice({
                    'Pronari': response.payload.response.owner,
                    'Targa': props.plate,
                    'Shasia': response.payload.response.vin,
                    'Modeli makinës': response.payload.response.make + ' ' + response.payload.response.model,
                    'Viti i prodhimit': response.payload.response.year,
                    'Periudha e fillimit': response.payload.response.startDate.split(" ")[0],
                    'Kohëzgjatja': '1 Vjeçare',
                    'Përdorues i dytë': response.payload.response.secondDriver ? response.payload.response.secondDriver : '-',
                    'Çmimi': response.payload.response.totalPrice + ' ' + 'Lekë',
                    'Ulje': response.payload.response.discountPercentage,
                    'Zbritje në çmim': response.payload.response.discount + ' ' + 'Lekë',
                    'Totali': response.payload.response.price + ' ' + 'Lekë'
                });
                setDetailList(true)
            }
        })
    }

    const getOffer = () => {
        if (isSecondDriver) {
            dispatch(sendGeneralRequest({ request: { token: state.token, trxid: props.transID, taxNumber: state.secondDriverID, isLocal: true, firstName: state.secondDriverName, lastName: state.secondDriverSurname, phoneNumber: null, email: null, addressCountry: 'AL', contactType: 'Person', fathersName: state.secondDriverFatherName, birthday: parseDate(state.secondDriverBirth), genderType: state.secondDriverGender }, baseUrlKey: 'services', endpoint: 'SigurimeMotorrike/AddDriverForPolicy' })).then(response => {
                if (response.payload.response.success) {
                    getPremiumForPolicy()
                }
            })
        }
        else {
            getPremiumForPolicy()
        }
    }

    const isButtonDisabled = () => {
        return !date || (isSecondDriver && (!state.secondDriverName || !state.secondDriverFatherName || !state.secondDriverSurname || !state.secondDriverID || !state.secondDriverBirth || !state.secondDriverGender))
    }

    const useStyles = makeStyles({
        mainGrid: {
            padding: '5%',
            paddingTop: '3%',
            height: 'auto'
        },
        utilityName: {
            color: colors.orange,
            fontSize: '1.2rem',
            fontFamily: 'GerberaBold',
            paddingTop: '3%',
            paddingLeft: '2%'
        },
        headerBox: {
            backgroundColor: colors.cyan,
            borderRadius: '100%',
            width: '50px',
            height: '50px'
        },
        fieldTitle: {
            color: colors.darkBlue,
            fontSize: '1.2rem',
            fontFamily: 'GerberaBold',
            textAlign: 'left'
        },
        button: {
            width: '100%',
            color: colors.white,
            fontSize: '1rem',
            textTransform: 'none',
            background: colors.gradientOrange,
            fontFamily: 'GerberaBold'
        },
        buttonGrid: {
            marginTop: 10,
            paddingBottom: 5
        },
        image: {
            width: '45%',
        },
        textField: {
            width: '100%'
        }
    })

    const classes = useStyles()

    return (
        <>
            {detailList ? (
                <SingleExpandedInvoice utilityName={'SIGURIIME_MOTORRIKE'} invoice={invoice} globalDataSliceState={props.data.globalDataSliceState} transID={props.transID} />
            ) : (
                <Grid container item className={classes.mainGrid} rowSpacing={2}>
                    <Grid container item md={2} xs={2} mt={2} >
                        <Link component={'button'} onClick={() => { navigate(-1) }}>
                            <ArrowBackIosNewIcon color='warning' />
                        </Link>
                    </Grid>
                    <Grid container item md={12} xs={12}>
                        <Accordion defaultExpanded style={{ width: isSmallScreen ? '80vw' : '30vw' }}>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon color='warning' />}
                                aria-controls="panel2-content"
                                id="panel2-header"
                            >
                                <Grid container direction="row" justifyContent="center" alignItems="center" className={classes.headerBox} >
                                    <img src={props.data.utilityInfo.Images.filter(image => image.color === 1 && image.size === 1)[0].imagePath} className={classes.image} />
                                </Grid>
                                <Typography className={classes.utilityName} >{props.data.utilityInfo.PublicName}</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                    <Typography style={{ fontFamily: 'GerberaMedium', color: colors.darkBlue }}>Pronari:</Typography>
                                    <Typography style={{ fontFamily: 'GerberaLight', color: colors.gray }}>{props.client}</Typography>
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                    <Typography style={{ fontFamily: 'GerberaMedium', color: colors.darkBlue }}>Targa:</Typography>
                                    <Typography style={{ fontFamily: 'GerberaLight', color: colors.gray }}>{props.plate}</Typography>
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                    <Typography style={{ fontFamily: 'GerberaMedium', color: colors.darkBlue }}>Shasia:</Typography>
                                    <Typography style={{ fontFamily: 'GerberaLight', color: colors.gray }}>{props.vin}</Typography>
                                </div>
                            </AccordionDetails>
                        </Accordion>
                    </Grid>
                    <Grid container item md={12} xs={12} mt={2}>
                        <FloatLabel>
                            <Calendar inputId="birth_date" style={{ width: isSmallScreen ? '80vw' : '28vw' }} value={date} onChange={(e) => setDate(e.value)} showIcon minDate={new Date()} maxDate={new Date(new Date().setDate(new Date().getDate() + 15))} dateFormat="dd/mm/yy"/>
                            <label style={{ color: colors.darkGray }} htmlFor="start_date">Data e fillimit</label>
                        </FloatLabel>
                    </Grid>
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '100%', marginTop: '10px' }}>
                        <Typography style={{ fontFamily: 'GerberaMedium', color: colors.darkBlue, marginTop: 6 }}>Përdoruesi i dytë?</Typography>
                        <Switch checked={isSecondDriver} onChange={(e) => setIsSecondDriver(e.target.checked)} color='warning' inputProps={{ 'aria-label': 'controlled' }} />
                    </div>
                    {
                        isSecondDriver && (
                            <>
                                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '15px 40px' }}>
                                    <Grid container item md={5.5} xs={12}>
                                        <TextField onChange={handleTextFieldChange('secondDriverName')} value={state.secondDriverName} color='warning' size='small' label={texts["productName"]} className={classes.textField} />
                                    </Grid>
                                    <Grid container item md={5.5} xs={12}>
                                        <TextField onChange={handleTextFieldChange('secondDriverFatherName')} value={state.secondDriverFatherName} color='warning' size='small' label={texts["placeholder-father-name"]} className={classes.textField} />
                                    </Grid>
                                    <Grid container item md={5.5} xs={12}>
                                        <TextField onChange={handleTextFieldChange('secondDriverSurname')} value={state.secondDriverSurname} color='warning' size='small' label={texts["dialog-lastname"]} className={classes.textField} />
                                    </Grid>
                                    <Grid container item md={5.5} xs={12}>
                                        <TextField onChange={handleTextFieldChange('secondDriverID')} value={state.secondDriverID} color='warning' size='small' label='ID' className={classes.textField} />
                                    </Grid>
                                    <Grid container item md={5.5} xs={12} mt={1}>
                                        <FloatLabel>
                                            <Calendar inputId="birth_date" style={{ width: isSmallScreen ? '80vw' : '13vw' }} value={state.secondDriverBirth} onChange={(e) => { const selectedDate = e.value; setState((prevState) => ({ ...prevState, secondDriverBirth: selectedDate })); }} showIcon dateFormat="dd/mm/yy" minDate={minAllowedDate} maxDate={maxAllowedDate} />
                                            <label style={{ color: colors.darkGray }} htmlFor="start_date">Ditëlindja</label>
                                        </FloatLabel> 
                                    </Grid>
                                    <Grid container item md={5.5} xs={12} flexDirection='column' >
                                        <Grid container item justifyContent='flex-start' >
                                            <Typography className={classes.fieldTitle} style={{ fontSize: '12px' }}>{texts["title-registration-gender"]}</Typography>
                                        </Grid>
                                        <Grid container item justifyContent='flex-start' >
                                            <RadioGroup name="gender" row aria-labelledby="demo-row-radio-buttons-group-label" value={state.secondDriverGender} onChange={(e) => { setState((prevState) => ({ ...prevState, secondDriverGender: e.target.value })) }}>
                                                <FormControlLabel sx={{ color: colors.darkBlue, fontFamily: 'GerberaLight' }} color={'warning'} value={'Male'} control={<Radio color='warning' checked={(state.secondDriverGender === 'Male')} />} label={texts["gender-male"]} />
                                                <FormControlLabel sx={{ color: colors.darkBlue, fontFamily: 'GerberaLight' }} color={'warning'} value={'Female'} control={<Radio color='warning' checked={(state.secondDriverGender === 'Female')} />} label={texts["gender-female"]} />
                                            </RadioGroup>
                                        </Grid>
                                    </Grid>
                                </div>
                            </>
                        )
                    }
                    <Grid item md={12} xs={12} className={classes.buttonGrid} >
                        <Button disabled={isButtonDisabled()} onClick={getOffer} className={classes.button}>
                            {texts["button-continue"]}
                        </Button>
                    </Grid>
                </Grid>
            )}
        </>
    )
}

export default AddDriversTpl;
